/**
 * ODDFISH — Lightweight scroll reveal (replaces AOS on blog/footer)
 */
(function () {
  "use strict";

  function prefersReducedMotion() {
    return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  }

  function reveal(el) {
    el.classList.add("oddfish-revealed");
  }

  function bindReveal(el) {
    if (!el || el.dataset.oddfishRevealBound) return;
    el.dataset.oddfishRevealBound = "true";

    if (prefersReducedMotion() || !("IntersectionObserver" in window)) {
      reveal(el);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          reveal(entry.target);
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -8% 0px" }
    );

    observer.observe(el);
  }

  function boot(scope) {
    var root = scope || document;
    root.querySelectorAll("[data-reveal]").forEach(bindReveal);
  }

  document.documentElement.classList.add("js");

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      boot(document);
    });
  } else {
    boot(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    boot(event.target);
  });

  window.OddfishReveal = { boot: boot, reveal: reveal };
})();
